import { useState, useEffect } from 'react'

const botUserAgents = [
  /bot/i,
  /crawler/i,
  /spider/i,
  /crawling/i,
  /googlebot/i,
  /bingbot/i,
  /yandexbot/i,
  /duckduckbot/i,
  /slurp/i,
]

export const useBot = () => {
  const [isBot, setIsBot] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent
    const detected = botUserAgents.some(botPattern => botPattern.test(userAgent))
    setIsBot(detected)
  }, [])

  return isBot
}
